import * as core from '../../../../../../../core'
import * as pullRequestMergeState from '../pull-request-merge-state'

export const RESOURCE = {
  payload: {
    description: 'The pull request was merged',
    enumId: core.dms.models.Enum.Id.from({
      partialId: pullRequestMergeState.RESOURCE.payload.partialId,
    }),
    id: 'MERGED',
    name: 'Merged',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
